import React from "react";
import { FaChartBar, FaLuggageCart } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";
import { FaChartArea } from "react-icons/fa";

import { TiShoppingCart } from "react-icons/ti";
import { FaSackDollar } from "react-icons/fa6";
const TopMenu = ({ data }) => {
  // todaysTotalSale,
  // todaysTotalIncome,
  // todaysTotalsellQuantity,
  // totalSale,
  // totalCost,
  // netIncome,
  return (
    <div className="dash_graph_top">
      <div className="top_g top_g1" style={{
          background: "rgba(249, 176, 191, 0.1)", /* soft pink */
          border: ".05vw solid #000000", // slightly darker pink border
          borderRadius: "5px",        // rounded corners
          boxShadow: "10px 8px 20px rgba(0, 0, 0, 0.2)", // subtle shadow
          
        }}>
        <div className="icon_div">
          <FaChartLine style={{ color: "#dd4f4f", fontSize: "3.2vw" }} />
        </div>
        <div 
        >
          <h1 
                    style={{
                      fontSize:"1vw",
                      marginRight:"3px",
                    }}>Today's sales</h1>
          <h2 className="amount">{data.todaysTotalSale} Tk</h2>
        </div>
      </div>
      <div className="top_g top_g2" style={{
            background: "rgba(249, 176, 191, 0.1)", /* soft pink */
          border: ".05vw solid #000000", // slightly darker pink border
          borderRadius: "5px",        // rounded corners
          boxShadow: "10px 8px 20px rgba(0, 0, 0, 0.2)", // subtle shadow
          
        }}>
        <div className="icon_div">
          <FaChartArea style={{ color: "#f39c12", fontSize: "3.2vw" }} />
        </div>
        <div className="details_div">
          <h1
                    style={{
                      fontSize:"1vw",
                      marginRight:"3px"
                    }}>Today's Income</h1>
          <h2 className="amount">{data.todaysTotalIncome} Tk</h2>
        </div>
      </div>
      <div className="top_g top_g3" style={{
          background: "rgba(249, 176, 191, 0.1)", /* soft pink */
          border: ".05vw solid #000000", // slightly darker pink border
          borderRadius: "5px",        // rounded corners
          boxShadow: "10px 8px 20px rgba(0, 0, 0, 0.2)", // subtle shadow
          
        }}>
        <div className="icon_div">
          <FaLuggageCart style={{ color: "	#7158E2", fontSize: "3.2vw" }} />
        </div>
        <div className="details_div">
          <h1 
                    style={{
                      fontSize:"1vw",
                      marginRight:"3px"
                    }}>Sale Quantity</h1>
          <h2 className="amount">{data.todaysTotalsellQuantity}</h2>
        </div>
      </div>
      <div className="top_g top_g4" style={{
          background: "rgba(249, 176, 191, 0.1)", /* soft pink */
          border: ".05vw solid #000000", // slightly darker pink border
          borderRadius: "5px",        // rounded corners
          boxShadow: "10px 8px 20px rgba(0, 0, 0, 0.2)", // subtle shadow
          
        }}>
        <div className="icon_div">
          <FaChartBar style={{ color: "#9B59B6	", fontSize: "3.2vw" }} />
        </div>
        <div className="details_div">
          <h1 
            style={{
                      fontSize:"1vw",
                      marginRight:"3px"
                    }}>Total Sales</h1>
          <h2 className="amount">{data.totalSaleAmount} Taka</h2>
        </div>
      </div>
      <div className="top_g top_g5" style={{
            background: "rgba(249, 176, 191, 0.1)", /* soft pink */
          border: ".05vw solid #000000", // slightly darker pink border
          borderRadius: "5px",        // rounded corners
          boxShadow: "10px 8px 20px rgba(0, 0, 0, 0.2)", // subtle shadow
          
        }}>
        <div className="icon_div">
          <TiShoppingCart style={{ color: "#008080", fontSize: "3.2vw" }} />
        </div>
        <div>       
          <h1 
          style={{
            fontSize:"1vw",
            marginRight:"3px"
          }}
          >Total Purchase</h1>
          <h2 
            style={{
              fontSize:"1vw",
              marginRight:"3px"
            }}>{data.totalPurchaseAmount} Tk</h2>
        </div>
      </div>
      <div className="top_g top_g6" style={{
            background: "rgba(249, 176, 191, 0.1)", /* soft pink */
          border: ".05vw solid #000000", // slightly darker pink border
          borderRadius: "5px",        // rounded corners
          boxShadow: "10px 8px 20px rgba(0, 0, 0, 0.2)", // subtle shadow
          
        }}>
        <div className="icon_div">
          <FaSackDollar style={{ color: "#009CFF", fontSize: "3.2vw" }} />
        </div>
        <div className="details_div">
          <h1 className="details_title">Net Income</h1>
          <h2 className="amount">{data.netIncome} Tk</h2>
        </div>
      </div>
    </div>
  );
};

export default TopMenu;
